import { useState } from 'react';
import { faqData } from '@/mocks/data';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-sm font-medium text-primary-600 mb-2">常见问题</p>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            您可能想了解
          </h2>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="border border-background-200 rounded-xl overflow-hidden transition-all duration-200"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left bg-background-50 hover:bg-background-100 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}